module.exports = __webpack_public_path__ + "img/RClinicus64_ua.58d8b46c.webp";